import * as Yup from 'yup';

export default Yup.object().shape({
  subject: Yup.string().required('Campo obrigatório'),
  email: Yup.string().email('E-mail inválido'),
  description: Yup.string().required('Campo obrigatório'),
});
